export const getErrorLogData = (error: any) => {
  return {
    errorMessage: error?.message,
    errorStack: error?.stack,
    error,
  };
};
